/**
 * Haptic feedback of the game arena (plan 47 § The stamp): a light tick on a
 * positive stamp («¡Perfecto!» / «¡Bien!») and a success pattern on a streak
 * milestone — never on a miss, which is not a punishment.
 *
 * Native app only (`@capacitor/haptics`): on the web there is no reliable
 * vibration (iOS Safari has none, a desktop vibrates nothing). Same switch as
 * the sound effects: with the effects muted, no haptics either.
 */
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { readSfxMuted } from '@orborix/voice-client';
import { isNative } from './platform.js';

/** `tick` = a positive stamp; `success` = a streak milestone. */
export type HapticCue = 'tick' | 'success';

let muted = typeof window === 'undefined' ? true : readSfxMuted();
if (typeof window !== 'undefined') {
  window.addEventListener('orborix:pref.sfxMuted', (e: Event) => {
    const detail = (e as CustomEvent<boolean>).detail;
    if (typeof detail === 'boolean') muted = detail;
  });
}

export function haptic(cue: HapticCue): void {
  if (!isNative || muted) return;
  const run =
    cue === 'tick'
      ? Haptics.impact({ style: ImpactStyle.Light })
      : Haptics.notification({ type: NotificationType.Success });
  run.catch((err: unknown) => {
    console.warn('[haptics] the device refused the haptic', cue, err);
  });
}
